<template>
    <el-dialog class="haveTable" title="元数据列表详情" width="65%" append-to-body :close-on-click-modal="false" :visible.sync="visible">
        <div class="el-table-container">
            <el-radio-group class="m_b1" v-model="showList" size="small" @input="reset(1)">
                <el-radio-button label="0">相同元数据</el-radio-button>
                <el-radio-button label="1">不同元数据</el-radio-button>
            </el-radio-group>
            <el-form size="small" :inline="true" ref="searchForm" :model="searchForm"
                     @keyup.enter.native="refreshList(1)">
                <el-form-item prop="findId" label="所属模板：" v-show="showList == '1'">
                    <el-select v-model="searchForm.findId" placeholder="请选择" clearable @change="selFindId">
                        <el-option
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                                v-for="item in basicDataIdOpt">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="basicType" label="元数据类型：">
                    <el-select v-model="searchForm.basicType" placeholder="请选择元数据类型" clearable>
                        <el-option
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                                v-for="item in $dictUtils.getDictList('basic_type')">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="basicName" label="元数据名称：">
                    <el-input v-model.trim="searchForm.basicName" maxlength="50" placeholder="请输入元数据名称"
                              clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="refreshList(1)" icon="el-icon-search">查询</el-button>
                    <el-button @click="reset()" icon="el-icon-refresh-right">重置</el-button>
                </el-form-item>
            </el-form>
            <el-table
                    :data="dataList"
                    v-loading="loading"
                    size="small" height="100%"
                    class="table" ref="multipleTable" border>
                <el-table-column type="index" label="序号" show-overflow-tooltip></el-table-column>
                <el-table-column prop="basicName" label="元数据名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="basicType" label="元数据类型" show-overflow-tooltip>
                    <template slot-scope="{row}">
                        {{$dictUtils.getDictLabel("basic_type", row.basicType ,'')}}
                    </template>
                </el-table-column>
                <el-table-column prop="assemblyName" label="组件类型" show-overflow-tooltip></el-table-column>
                <el-table-column prop="basicType" label="元数据模板位置" show-overflow-tooltip v-if="showList == '0'">
                    <template slot-scope="{row}">
                        <el-button type="text" size="small" @click="view(row)">查看</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="position" label="位置" show-overflow-tooltip v-if="showList == '1'"></el-table-column>
                <el-table-column prop="consistencyName" label="所属模板" show-overflow-tooltip v-if="showList == '1'"></el-table-column>
            </el-table>
            <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size" @pagination="refreshList"/>
        </div>
        <div slot="footer">
            <el-button size="small" @click="visible = false">关闭</el-button>
        </div>
        <LocationDetails ref="locationDetails"></LocationDetails>
    </el-dialog>
</template>

<script>
    import LocationDetails from './locationDetails'

    export default {
        components: {LocationDetails},
        data() {
            return {
                visible: false,
                loading: false,
                showList: '0',
                searchForm: {
                    basicDataId: '',
                    comparisonBasicDataId: '',
                    findId: '',
                    comparisonBasicDataIdFind: '',
                    basicDataIdFind: '',
                    basicType: '',
                    basicName: '',
                    current: 1,
                    size: 20,
                },
                basicDataIdOpt: [],
                dataList: [],
                total: 0,
            }
        },
        methods: {
            init(basicDataId, basicDataName, row) {
                this.showList = '0'
                this.searchForm.basicDataId = basicDataId
                this.searchForm.comparisonBasicDataId = row.basicDataId
                this.basicDataIdOpt = [
                    {
                        type: '1',
                        value: basicDataId,
                        label: basicDataName + '（比对模板）',
                    },
                    {
                        type: '2',
                        value: row.basicDataId,
                        label: row.consistencyName + '（被比对模板）',
                    }
                ]
                this.visible = true
                this.$nextTick(() => {
                    this.reset()
                })
            },
            refreshList(type) {
                if (type == 1) {
                    this.searchForm.current = 1
                }
                let api = this.api.metadata.alikeData
                if (this.showList == '1') {
                    api = this.api.metadata.imparityData
                }
                this.loading = true
                this.$axios(api, this.searchForm, 'post').then(data => {
                    if (data && data.status) {
                        this.dataList = data.data.records
                        if (this.dataList.length == 0 && this.searchForm.current > 1) {
                            this.searchForm.current--
                            this.refreshList()
                        }
                        this.total = parseInt(data.data.total)
                        this.loading = false
                    }
                })
            },
            // 选择所属模板
            selFindId(val) {
                let item = this.basicDataIdOpt.filter(v => v.value == val)[0]
                if(item.type == '1') {
                    this.searchForm.comparisonBasicDataIdFind = item.value
                    this.searchForm.basicDataIdFind = ''
                } else {
                    this.searchForm.comparisonBasicDataIdFind = ''
                    this.searchForm.basicDataIdFind = item.value
                }
            },
            // 查看
            view(row) {
                this.$refs.locationDetails.init(row, this.searchForm.basicDataId, this.searchForm.comparisonBasicDataId)
            },
            // 重置
            reset() {
                this.searchForm.basicDataIdFind = ''
                this.searchForm.comparisonBasicDataIdFind = ''
                this.$refs.searchForm.resetFields();
                this.refreshList(1)
            }
        }
    }
</script>

<style scoped>
    .numInfo {
        font-size: 10px;
        margin-bottom: 10px;
    }
    .el-button--text {
        padding: 0 10px 0 0 !important;
    }
</style>
